<!--
Copyright (c) 2001-present X-Cart Holdings LLC. All rights reserved.
See https://www.x-cart.com/license-agreement.html for license details.
-->

<template>
  <div id="module-modal">
    <module-details-dialog/>
  </div>
</template>

<script>
import ModuleDetailsDialog from './components/dialogs/ModuleDetailsDialog';

export default {
  name: 'ModuleModal',
  components: {
    ModuleDetailsDialog,
  },
};
</script>



// WEBPACK FOOTER //
// src/ModuleModal.vue